export const getColumnForDevicesTable = (t, cellActionDropdown) => {
  return [
    {
      Header: t('devicesPage.table.applications'),
      accessor: 'applicationName',
      id: 'applicationName',
      width: 100,
      selectElementWidth: 120,
    },
    {
      Header: t('devicesPage.table.device'),
      accessor: 'device',
      id: 'device',
      width: 120,
      selectElementWidth: 120,
    },
    {
      Header: t('devicesPage.table.numOfRefreshTokens'),
      accessor: 'numOfRefreshTokens',
      id: 'numOfRefreshTokens',
      width: 100,
      selectElementWidth: 120,
    },
    {
      Header: t('devicesPage.table.actions'),
      accessor: 'refreshTokenIds',
      id: 'refreshTokenIds',
      width: 60,
      selectElementWidth: 80,
      sortable: false,
      Cell: cell => cellActionDropdown(cell),
    },
  ];
};
